import "./style.scss";
import { FC, Fragment } from "react";
import { IUniversityPrograms } from "@/src/types/IUniversityPrograms";
import UniversityProgramsCard from "../UniversityProgramsCardDesk/UniversityProgramsCardDesk";
import UniversityProgramsSlider from "../UniversityProgramsSliderDesk/UniversityProgramsSliderDesk";

interface IContent {
  content: IUniversityPrograms[];
  universityCardName: string;
  setUniversityCardName: (id: string) => void;
}

const UniversityProgramsContentDesk: FC<IContent> = ({ content, universityCardName, setUniversityCardName }) => {
  return (
    <div className="university-programs-content">
      <div className="university-programs-cards">
        {content.map((item, index) => (
          <Fragment key={index}>
            <UniversityProgramsCard
              name={item.name}
              img={item.img}
              universityCardName={universityCardName}
              setUniversityCardName={setUniversityCardName}
            />
          </Fragment>
        ))}
      </div>
      {content.map(
        (item, index) =>
          item.name === universityCardName && (
            <Fragment key={index}>
              <UniversityProgramsSlider programs={item.programs} />
            </Fragment>
          )
      )}
    </div>
  );
};

export default UniversityProgramsContentDesk;
